<script>
import { listRecords, importRecords, getTime } from '../../../api/visitRecords';
import moment from 'moment';
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

export default {
  components: {},
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
      },
      en,
      zh,
      list: [],
      loading: false,
      pageNo: 1,
      limit: 10,
      total: 0,
      formLabelWidth: '120px',
      value2: '',
      select: {
        dept: '',
        serviceMan: '',
        customer: '',
        machineNumber: '',
        phone: '',
        linkMan: '',
        startTime: '',
        endTime: '',
      },
      TimeData: [],
      dialogFormVisible: false,
      allYear: [],
      chooseMonth: [],
      selectTime: {
        year: '',
        month: ''
      },
      pickerOptions: {
        shortcuts: [{
          text: this.$t('station.tld'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('station.tlw'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('station.tlm'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  mounted() {
    this.ListC()
  },
  methods: {
    translate() {
      locale.use(this[this.lang])
      this.pickerOptions = {
        shortcuts: [{
          text: this.$t('station.tld'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('station.tlw'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('station.tlm'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    },
    async ListC(pager = 1) {
      if (this.value2 != '' && this.value2) {
        console.log(this.value2);
        this.select.startTime = moment(+this.value2[0]).format('YYYY-MM-DD HH:mm:ss')
        this.select.endTime = moment(+this.value2[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      console.log(pager);
      this.pageNo = pager
      const formdata = new FormData()
      formdata.append('dept', this.select.dept)
      formdata.append('serviceMan', this.select.serviceMan)
      formdata.append('customer', this.select.customer)
      formdata.append('machineNumber', this.select.machineNumber)
      formdata.append('phone', this.select.phone)
      formdata.append('linkMan', this.select.linkMan)
      formdata.append('startTime', this.select.startTime)
      formdata.append('endTime', this.select.endTime)
      console.log(this.pageNo);
      const result = await listRecords(this.pageNo, this.limit, formdata)
      console.log(result);
      if (result.code == 0) {
        this.total = result.data.total
        this.list = result.data.records
        console.log(this.list);
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    importExcel() {
      const input = document.querySelector('#importDom')
      input.click()
    },
    async importE(e) {
      console.log(e.target.files[0]);
      const formdata = new FormData()
      formdata.append('excelFile', e.target.files[0])
      const result = await importRecords(formdata)
      console.log(result);
      if (result.code == 0) {
        this.$notify.success({
          title: this.$t('visitRecords.importSuccessfully'),
          message: result.message
        });
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    refresh() {
      this.value2 = ''
      this.select.startTime = ''
      this.select.endTime = ''
    },
    Select() {
      this.ListC()
    },
    async openTime() {
      const result = await getTime()
      if (result.code == 0) {
        this.TimeData = result.data
        result.data.forEach(e => {
          this.allYear.push(e.year)
        })
        console.log(this.allYear);
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
      this.dialogFormVisible = true
    },
    getM() {
      const chose = this.TimeData.find(e => e.year == this.selectTime.year)
      this.chooseMonth = chose.time.map(e => e.month

      )
    },
    closeD() {
      this.dialogFormVisible = false
      this.allYear = []
      this.chooseMonth = []
      this.selectTime.year = ''
      this.selectTime.month = ''
    },
    PicSC() {
      if (this.selectTime.year != '' && this.selectTime.month != '') {
        this.$router.push({
          path: '/RecordsPic',
          query: this.selectTime
        })
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: this.$t('messages.selectTime')
        });
      }
    }
  },

};

</script>
<template>
  <div>
    <div style="width: 100%; height: 100%">
      <div class="equipmentList">
        <div class="container">
          <div>
            <span>{{ $t('visitRecords.title') }}</span>
          </div>
          <div>
            <a-space>
              <a-button
                type="primary"
                @click="openTime"
              >
              {{ $t('device.chart') }}</a-button>
              <input
                id='importDom'
                type="file"
                style="display: none;"
                @change="importE"
              />
              <a-button
                type="primary"
                @click="importExcel"
              >
              {{ $t('visitRecords.import') }}</a-button>

            </a-space>
          </div>
        </div>
        <el-form style="display:inline-flex;">
          <el-form-item
            :label="$t('dataReport.datetime')"
            label-width="100px"
          >
            <div class="block">
              <el-date-picker
                :key="lang"
                v-model="value2"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('common.startTime')"
                :end-placeholder="$t('common.endTime')"
                :picker-options="pickerOptions"
                size="default"
              />
            </div>
          </el-form-item>
          <el-button
            type="primary"
            size="default"
            icon="Search"
            style="width: 80px;height: 40px;margin-left: 30px;"
            @click="Select"
          >{{ $t('buttons.search') }}</el-button>
          <el-button
            type="primary"
            size="default"
            icon="Refresh"
            style="width: 80px;height: 40px;"
            @click="refresh"
          >{{ $t('buttons.reset') }}</el-button>
        </el-form>

        <el-table
          :data="list"
          border
        >
          <el-table-column
            prop="serviceDate"
            :label="$t('saleDocument.serviceTime')"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="dept"
            label="部门"
            width="100"
          >
            <template #header>
              <div>{{ $t('visitRecords.department') }}</div>
              <el-input
                v-model="select.dept"
                @change="ListC(1)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="serviceMan"
            label="服务人员"
            width="100"
          >
            <template #header>
              <div>{{ $t('binding.serviceMan') }}</div>
              <el-input
                v-model="select.serviceMan"
                @change="ListC(1)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="customer"
            label="客户"
            width="160"
          >
            <template #header>
              <div>{{ $t('common.customer') }}</div>
              <el-input
                v-model="select.customer"
                @change="ListC(1)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="machineName"
            :label="$t('visitRecords.machineName')"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="serviceItem"
            :label="$t('visitRecords.serviceItem')"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="machineNumber"
            label="整机编号"
            width="160"
          >
            <template #header>
              <div>{{ $t('device.code') }}</div>
              <el-input
                v-model="select.machineNumber"
                @change="ListC(1)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系人手机号码"
            width="160"
          >
            <template #header>
              <div>{{ $t('visitRecords.phone') }}</div>
              <el-input
                v-model="select.phone"
                @change="ListC(1)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="linkMan"
            label="联系人"
            width="100"
          >
            <template #header>
              <div>{{ $t('orders.contactPerson') }}</div>
              <el-input
                v-model="select.linkMan"
                @change="ListC(1)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="q1"
            :label="$t('visitRecords.q1')"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="q2"
            :label="$t('visitRecords.q2')"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="q3"
            :label="$t('visitRecords.q3')"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="q4"
            :label="$t('visitRecords.q4')"
            width="140"
          >
          </el-table-column>
          <el-table-column
            prop="totalScore"
            :label="$t('visitRecords.totalScore')"
            width="50"
          >
          </el-table-column>
          <el-table-column
            prop="note"
            :label="$t('common.remark')"
            width="160"
          >
          </el-table-column>
          <el-table-column
            :label="$t('common.operation')"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
              >{{ $t('buttons.edit') }}</el-button>
              <el-button
                type="text"
                size="small"
              >{{ $t('buttons.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :key="lang"
          @size-change="ListC"
          @current-change="ListC"
          :pager-count="9"
          v-model:current-page="pageNo"
          v-model:page-size="limit"
          :page-sizes="[10, 20, 30, 40]"
          :background="true"
          layout="prev, pager, next, jumper,->, sizes,total"
          :total="total"
        />
      </div>

    </div>
    <el-dialog
      :title="$t('device.chart')"
      @close="closeD"
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="selectTime">
        <el-form-item
          :label="$t('visitRecords.activityName')"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="selectTime.year"
            :placeholder="$t('visitRecords.sy')"
            @change="getM"
          >
            <el-option
              v-for="item in allYear"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('visitRecords.area')"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="selectTime.month"
            :placeholder="$t('visitRecords.sm')"
          >
            <el-option
              v-for="item in chooseMonth"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogFormVisible = false">{{ $t('common.cancelText') }}</el-button>
        <el-button
          type="primary"
          @click="PicSC"
        >{{ $t('linkage.create') }}</el-button>
      </div>
    </el-dialog>
</div></template>


<style lang="less" scoped>.row {
  margin-top: 5px;
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.equipmentList {
  padding: 15px;
  width: 100%;
  height: 100%;
}

.equipmentList .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}</style>
